<template>
  <div class="loginContainer">
    <div style="text-align:center;padding-top:3.15rem;position:relative">
      <img src="../../assets/welcome.png" style="width:24.8rem;height:7.9rem" />
      <div
        style="font-size:1.8rem;color:#ffffff;position:absolute;right:2rem;top:3.15rem"
      >
        欢迎您：{{ teacher && teacher.account ? teacher.account.username : '' }}

        <span
          @click="$refs['change-pwd'].show({})"
          style="margin-left:10px;cursor:pointer"
          >修改密码</span
        >
      </div>
    </div>
    <div
      v-if="classes.length > 0 && loaded"
      style="margin-top:2rem;"
      class="flexBetween"
    >
      <div
        style="width:4.25rem;text-align:center;cursor: pointer;"
        @click="scrollPrev('bScroll')"
      >
        <img
          src="../../assets/class_arrow_left.png"
          style="width:2.5rem;height:3.6rem"
        />
      </div>
      <div
        style="width:calc( 100vw - 8.5rem );height:32rem;position:relative;overflow:scroll"
        ref="bScroll"
        class="bScroll"
      >
        <div
          ref="scrollContainer"
          class="flexAc"
          style="height:100%;width: auto"
        >
          <div
            v-for="(item, index) in classes"
            :id="'scrollItem' + index"
            :key="index"
            style="background:linear-gradient(to bottom right, rgba(255,255,255,0.7) 0%,  rgba(255,255,255,0.2) 50%,rgba(255,255,255,0.7) 100% );padding:0.3rem;border-radius:2rem;width:19.4rem;height:28.3rem;position: relative;cursor: pointer;"
            :style="index > 0 ? 'margin-left:1.5rem' : ''"
            class="flexCenter"
            @click="$router.push('/student_list?id=' + item.id)"
          >
            <div
              style="background:#ffffff;width:19.2rem;height:28.1rem;border-radius:1.5rem;position:relative;overflow:hidden"
            >
              <div class="classContainer flexCenter">
                <div style="width:14.4rem;height:14.4rem;padding-top:2.4rem;">
                  <div
                    v-for="(item1, index1) in item.student_list"
                    :key="index1"
                    style="display:inline-block;text-align:center;margin-bottom:0.6rem"
                    :style="index1 % 3 == 0 ? '' : 'margin-left:0.6rem'"
                  >
                    <img
                      :src="
                        item1.avatar
                          ? item1.avatar
                          : require('../../assets/default_avatar.png')
                      "
                      style="width:4.4rem;height:4.4rem;border-radius:50%"
                    />
                  </div>
                </div>
              </div>
              <div
                style="padding:0rem 1.5rem;position:absolute;top:19rem;left:0"
              >
                <div
                  style="color:#0F85DB;font-size:1.6rem;overflow: hidden;text-overflow: ellipsis; display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;"
                >
                  {{ item.name }}
                </div>
                <div
                  style="margin-top:0.5rem;color:#FFAA53;font-size:1.2rem;text-align:right;white-space: nowrap;overflow:hidden;text-overflow:ellipsis;width:16rem;"
                >
                  {{ item.goods_name }}
                </div>
                <div
                  style="margin-top:0.5rem;color:#999999;font-size:1.2rem;text-align:right"
                >
                  {{ item.session_start_time }}-
                  {{ item.session_end_time }}
                </div>
              </div>
            </div>
            <div
              v-if="item.state == '1'"
              style="position:absolute;width:8rem;height:3.2rem;text-align:center;line-height:3.2rem;font-size:1.2rem;color:#ffffff;background:#5DBFFF;border-radius:1.6rem;top:-1.6rem;left:calc( 50% - 4rem )"
            >
              即将开课
            </div>
            <div
              v-if="item.state == '0'"
              style="position:absolute;width:8rem;height:3.2rem;text-align:center;line-height:3.2rem;font-size:1.2rem;color:#ffffff;background:#FF7A8F;border-radius:1.6rem;top:-1.6rem;left:calc( 50% - 4rem )"
            >
              正在上课
            </div>
          </div>
        </div>
      </div>
      <div
        style="width:4.25rem;text-align:center;cursor: pointer;"
        @click="scrollNext('bScroll')"
      >
        <img
          src="../../assets/class_arrow_right.png"
          style="width:2.5rem;height:3.6rem"
        />
      </div>
    </div>
    <div
      v-if="classes.length == 0 && loaded"
      style="margin-top:6rem;"
      class="flexCenter"
    >
      <div
        style="width:44rem;height:31rem;font-size:1.6rem;color:#ffffff;position:relative"
      >
        <img
          src="../../assets/class_nodata.png"
          style="width:100%;height:100%"
        />
        <div
          style="position:absolute;width:100%;height:100%;top:0;left:0"
          class="flexCenter"
        >
          暂无班级信息
        </div>
      </div>
    </div>
    <bottom-bar
      @startClass="$router.push('/start_class')"
      right-bar="startClass"
    ></bottom-bar>
    <change-pwd ref="change-pwd"></change-pwd>
  </div>
</template>

<script>
import BottomBar from '../../components/BottomBar.vue'
import ChangePwd from '../../components/ChangePwd.vue'
// import {scrollX} from "../../utils/scroll.js"
export default {
  name: 'ClassList',
  components: {
    BottomBar,
    ChangePwd,
  },
  data() {
    return {
      loaded: false,
      scrollOffset: 0,
      bScroll: null,
      scrollWidth: '100%',
      classes: [],
      teacher: null,
    }
  },
  mounted() {
    let teacher = sessionStorage.getItem('xiaobi_teacher')
    if (teacher) {
      this.teacher = JSON.parse(teacher)
    }
    this.initData()
  },
  destroyed() {
    if (this.bScroll) {
      this.bScroll.destroy()
    }
  },
  methods: {
    initData() {
      this.$http
        .post('/api/v2/handwriting/BigScreen/get_teacher_class_list', {})
        .then((res) => {
          if (res.code == '200') {
            let classList = res.data
            this.classes = classList || []
            this.loaded = true
            this.$nextTick(() => {
              if (this.$refs['bScroll']) {
                this.$refs['bScroll'].addEventListener('scroll', (e) => {
                  this.scrollOffset = e.target.scrollLeft
                })
              }
            })
          }
        })
    },
    scrollPrev(pref) {
      let pobj = this.$refs[pref]
      let pw = pobj.offsetWidth

      let targetX = 0
      if (this.scrollOffset <= pw) {
        targetX = 0
      } else {
        targetX = this.scrollOffset - pw
      }
      pobj.scrollTo(targetX, 0)
      // scrollX(pobj,this.scrollOffset, targetX)
      this.scrollOffset = targetX
    },
    scrollNext(pref) {
      let pobj = this.$refs[pref]
      let pw = pobj.offsetWidth
      let sw = pobj.scrollWidth

      let targetX = 0
      if (this.scrollOffset + pw >= sw) {
        targetX = sw - pw
      } else {
        targetX = this.scrollOffset + pw
      }
      pobj.scrollTo(targetX, 0)
      // scrollX(pobj,this.scrollOffset, targetX)
      this.scrollOffset = targetX
    },
  },
}
</script>
<style scoped>
.bScroll::-webkit-scrollbar {
  display: none;
}

.loginContainer {
  width: 100vw;
  height: 100vh;
  background: url('../../assets/class_bg.png') no-repeat;
  background-size: 100% 100%;
}

.classContainer {
  width: 200%;
  position: absolute;
  top: 0;
  left: -50%;
  background: red;
  overflow: hidden;
  border-radius: 0 0 50% 50%;
  background: linear-gradient(
    0deg,
    rgba(15, 133, 219, 0.25) 0%,
    rgba(255, 255, 255, 0) 30%,
    rgba(255, 255, 255, 0) 100%
  );
}
</style>
